export default {
    API_URL: 'https://zedsever.net/',
    PUSHER_KEY: 'dffa347b3b443759ce2e',
    PAGE_TITLE: 'Business Help Center',
    LOGIN_URL: 'https://zedsever.net/',
    CLUSTER: 'mt1'
};